// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import React from 'react';
import { GLYPH_STROKE } from './glyph';
import type { SymbolGlyphProps } from './glyph';
import { RotatingMachine } from './RotatingMachine';

/**
 * Pump — the rotating-machine circle with the P&ID impeller triangle.
 *
 * ISA 5.1 draws a centrifugal pump as a circle with a triangle pointing along
 * the discharge; Ignition's pump symbols carry the same silhouette in
 * pictorial form. The triangle is what tells a chilled-water pump from a
 * chiller compressor at chip size — both are motors to the board, but an
 * operator asks "which pump" far more often than "which motor".
 */
export const PumpSymbol = ({ size = 18, run, leads }: SymbolGlyphProps) => (
  <RotatingMachine size={size} run={run} leads={leads}>
    <path
      className="sld-glyph__mark"
      d="M8.5 7.5 L16.5 12 L8.5 16.5 Z"
      stroke="currentColor"
      strokeWidth={GLYPH_STROKE - 0.3}
      strokeLinejoin="round"
    />
  </RotatingMachine>
);
